export class OrderImageResponse {
    httpStatus: String;
    response: {
        id: String,
        codeResponse: String,
        response: String,
        nroTotalFilas:Number,
        nroTotalPaginas:Number,
        document:String,
        list: []
    }    
    constructor(){
        this.httpStatus = "";
        this.response = {
            id: "",
            codeResponse: "",
            response: "",
            nroTotalFilas:0,
            nroTotalPaginas:0,
            document:"",
            list: []
        } 
    }
}
